import React, { Component } from 'react';
import './Note.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Moment from 'moment';

/**
 * NoteReview - 振り返り入力 + AIアドバイスセクション
 *
 * Props:
 *   - reviewGoal, reviewBad, reviewWhy, reviewAction: string
 *   - onChangeReview: (field, value) => void
 *   - onLoadLastReview: () => void
 *   - aiAdvice: string
 *   - aiAdviceGeneratedAt: string
 *   - adviceError: string | null
 *   - isGeneratingAdvice: boolean
 *   - onGenerateAdvice: () => void
 *   - isLoadingReview: boolean
 */
export default class NoteReview extends Component {

    // アドバイス生成日時のフォーマット
    formatAdviceDate = (dateStr) => {
        if (!dateStr) return '';
        return Moment(dateStr).format('YYYY/MM/DD HH:mm');
    }

    render() {
        const {
            reviewGoal, reviewBad, reviewWhy, reviewAction,
            onChangeReview, onLoadLastReview,
            aiAdvice, aiAdviceGeneratedAt, adviceError,
            isGeneratingAdvice, onGenerateAdvice,
            isLoadingReview,
        } = this.props;

        return (
            <div>
                {/* 振り返り入力セクション */}
                <div className="note-card">
                    <div className="note-card-header">
                        <span>
                            <FontAwesomeIcon icon="clipboard" className="header-icon" />
                            振り返り
                        </span>
                        <button
                            className="btn-load-review"
                            onClick={onLoadLastReview}
                            disabled={isLoadingReview}
                        >
                            <FontAwesomeIcon icon="download" /> 最新をロード
                        </button>
                    </div>
                    <div className="note-card-body">
                        <div className="review-field">
                            <label>🎯 目標</label>
                            <textarea
                                value={reviewGoal}
                                onChange={(e) => onChangeReview('reviewGoal', e.target.value)}
                                placeholder="今日の練習の目標は？"
                            />
                        </div>
                        <div className="review-field">
                            <label>❌ ダメだったこと</label>
                            <textarea
                                value={reviewBad}
                                onChange={(e) => onChangeReview('reviewBad', e.target.value)}
                                placeholder="うまくいかなかったことは？"
                            />
                        </div>
                        <div className="review-field">
                            <label>🤔 なぜ</label>
                            <textarea
                                value={reviewWhy}
                                onChange={(e) => onChangeReview('reviewWhy', e.target.value)}
                                placeholder="なぜうまくいかなかったか？"
                            />
                        </div>
                        <div className="review-field">
                            <label>💡 次にどうすれば</label>
                            <textarea
                                value={reviewAction}
                                onChange={(e) => onChangeReview('reviewAction', e.target.value)}
                                placeholder="次回への改善策は？"
                            />
                        </div>
                    </div>
                </div>

                {/* AIコーチからのアドバイスセクション */}
                <div className="note-card">
                    <div className="note-card-header">
                        <span>
                            <FontAwesomeIcon icon="brain" className="header-icon" />
                            AIコーチからのアドバイス
                        </span>
                    </div>
                    <div className="note-card-body ai-advice-section">
                        {aiAdvice && (
                            <>
                                <div className="ai-advice-text">{aiAdvice}</div>
                                {aiAdviceGeneratedAt && (
                                    <div className="ai-advice-date">
                                        生成日時: {this.formatAdviceDate(aiAdviceGeneratedAt)}
                                    </div>
                                )}
                            </>
                        )}

                        {adviceError && (
                            <div className="ai-advice-error">{adviceError}</div>
                        )}

                        <button
                            className="btn-generate-advice"
                            onClick={onGenerateAdvice}
                            disabled={isGeneratingAdvice}
                        >
                            {isGeneratingAdvice ? (
                                <>
                                    <span className="spinner"></span>
                                    アドバイスを生成中...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon="magic" />
                                    {aiAdvice ? 'AIに再度アドバイスを求める' : 'AIにアドバイスを求める'}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
